import pluralize from 'pluralize-ru';

import { ProviderType } from './context';
import { getDateParts } from './helpers';

const monthsInFullDates = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

const monthsInShortDates = [
  'январь',
  'февраль',
  'март',
  'апрель',
  'май',
  'июнь',
  'июль',
  'август',
  'сентябрь',
  'октябрь',
  'ноябрь',
  'декабрь',
];

export function getCalendarDisclosureLabel({
  selectionType = 'day',
  selectedDate,
  selectionDateType = 'day',
  multiple = false,
}: Pick<
  ProviderType,
  'selectionType' | 'selectedDate' | 'selectionDateType'
> & {
  multiple?: boolean;
}) {
  const isSelectedDateEmpty = !selectedDate || selectedDate.length === 0;
  if (isSelectedDateEmpty) {
    if (selectionType === 'day') {
      switch (selectionDateType) {
        case 'day':
          return 'Выберите дату';
        case 'month':
          return 'Выберите месяц';
        case 'year':
          return 'Выберите год';
      }
    } else {
      switch (selectionDateType) {
        case 'day':
          return 'Выберите несколько дат';
        case 'month':
          return 'Выберите несколько месяцев';
        case 'year':
          return 'Выберите несколько лет';
      }
    }
  }

  if (selectionType === 'day' && multiple) {
    switch (selectionDateType) {
      case 'day':
        const pluralizedDays = pluralize(
          selectedDate!.length,
          'Выбрано %d дат',
          'Выбрана %d дата',
          'Выбрано %d даты',
          'Выбрано %d дат'
        );
        const mappedDays = selectedDate!.map((date) => {
          const { day, month, year } = getDateParts(date);
          return `${day} ${monthsInFullDates[month]} ${year}`;
        });
        return `${pluralizedDays}: ${mappedDays.join(', ')}`;
      case 'month':
        const mappedMonths = selectedDate!.map((date) => {
          const { month, year } = getDateParts(date);
          return `${monthsInShortDates[month]} ${year}`;
        });
        const uniqMonths = Array.from(new Set(mappedMonths));
        const pluralizedMonths = pluralize(
          uniqMonths.length,
          'Выбрано %d месяцев',
          'Выбран %d месяц',
          'Выбрано %d месяца',
          'Выбрано %d месяцев'
        );
        return `${pluralizedMonths}: ${uniqMonths.join(', ')}`;
      case 'year':
        const mappedYears = selectedDate!.map((date) => {
          const { year } = getDateParts(date);
          return year;
        });
        const uniqYears = Array.from(new Set(mappedYears));
        const pluralizedYears = pluralize(
          uniqYears.length,
          'Выбрано %d лет',
          'Выбран %d год',
          'Выбрано %d года',
          'Выбрано %d лет'
        );
        return `${pluralizedYears}: ${uniqYears.join(', ')}`;
    }
  } else if (selectionType === 'day' || selectedDate![0] === selectedDate![1]) {
    const { day, month, year } = getDateParts(selectedDate![0]);
    switch (selectionDateType) {
      case 'day':
        return `Выбрано ${day} ${monthsInFullDates[month]} ${year}`;
      case 'month':
        return `Выбран ${monthsInShortDates[month]} ${year}`;
      case 'year':
        return `Выбран ${year}`;
    }
  } else {
    const { day: startDay, month: startMonth, year: startYear } = getDateParts(
      selectedDate![0]
    );
    const { day: endDay, month: endMonth, year: endYear } = getDateParts(
      selectedDate![1]
    );
    switch (selectionDateType) {
      case 'day':
        return `Выбрано с ${startDay} ${monthsInFullDates[startMonth]} ${startYear} по ${endDay} ${monthsInFullDates[endMonth]} ${endYear}`;
      case 'month':
        return `Выбрано с ${monthsInFullDates[startMonth]} ${startYear} по ${monthsInShortDates[endMonth]} ${endYear}`;
      case 'year':
        return `Выбрано с ${startYear} по ${endYear}`;
    }
  }
}
